import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { SelfCollectionModalCard } from "./self-collection-modal-card.component";

export const SelfCollectionActivationCompletePage = () => {
  usePageViewAnalytics({ screen_name: "Self Collection Activation Complete" });
  const { formatMessage } = useIntl();

  useDocumentTitle(
    formatMessage({ id: "STR_SELF_COLLECTION_ACTIVATION_COMPLETE" })
  );

  return (
    <SelfCollectionModalCard>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ACTIVATION_COMPLETE}
      />
    </SelfCollectionModalCard>
  );
};
